import { BPCTableField } from '@shared/interfaces/bpc-table-interface';

// Config to display columns
export const ActivitySessionWaitingContactDisplayFields = {
  activitySession: {
    displayType: 'badge',
    key: 'activitySession',
  },
  contact: {
    displayType: 'contact-link',
    useDrawer: true,
    formConfigName: 'edit',
    drawerSize: 'lg',
    configFileName: 'contact',
  },
  created_at: {
    displayType: 'date',
    key: 'created_at',
  },
  date: {
    displayType: 'date',
    key: 'date',
  },
};

// Columns displayed by default
export const defaultTableFields: BPCTableField[] = [
  {
    key: 'contact.fullname',
    headerLabel: `global.contact_fullname_header`,
    order: 0,
  },
  {
    key: 'activity_session.code',
    headerLabel: `global.activity_session_code_header`,
    order: 1,
  },
  {
    key: 'activity_session.name',
    headerLabel: `activities.activity_session.name.label`,
    order: 2,
  },
  {
    key: 'activity_session.formated_date',
    headerLabel: `activities.activity_session.date.label`,
    order: 3,
  },
  {
    key: 'activity_session.formated_time_range',
    headerLabel: `activities.activity_session.time_range.label`,
    order: 4,
  },
  {
    key: 'created_at',
    headerLabel: `global.created_at_header`,
    order: 5,
  },
];
